const supportedIconNames = {
  back: require('./Back'),
  add: require('./Add'),
  subtract: require('./Subtract'),
  multiply: require('./Multiply'),
  divide: require('./Divide'),
};

export default supportedIconNames;
